import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-8 md:py-16 px-4 bg-slate-900 text-white text-center" data-id="element-64">
      <div className="max-w-3xl mx-auto" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/20 px-4 py-2 rounded-full mb-4" data-id="element-66">
          <span className="text-red-500 text-xs md:text-sm font-bold uppercase tracking-wider" data-id="element-67">
            🔥 Esta oferta puede terminar en cualquier momento
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-7xl font-black mb-3 leading-tight" data-id="element-68">
          Tu año de Química, <br data-id="element-69" />
          <span className="text-blue-500" data-id="element-70">resuelto.</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-slate-400 text-lg md:text-2xl font-bold mb-6" data-id="element-71">
          Dejá de improvisar. Empezá a disfrutar tus clases.
        </motion.p>

        <motion.button animate={{
        boxShadow: ['0 0 15px rgba(34,197,94,0.2)', '0 0 25px rgba(34,197,94,0.4)', '0 0 15px rgba(34,197,94,0.2)']
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        boxShadow: {
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut'
        },
        opacity: {
          delay: 0.3
        },
        scale: {
          delay: 0.3
        }
      }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full max-w-md bg-green-600 hover:bg-green-700 text-white font-black text-xl md:text-2xl py-6 rounded-2xl shadow-[0_20px_50px_rgba(34,197,94,0.3)] mb-8 uppercase tracking-tight" data-id="element-72">
          ⚗️ → QUIERO MI MEGAPACK AHORA
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex flex-col items-center gap-4" data-id="element-73">
          <div className="flex items-center gap-2 bg-green-500/10 px-4 py-1.5 rounded-full border border-green-500/20" data-id="element-74">
            <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-75" />
            <span className="text-green-500 text-xs md:text-sm font-black uppercase tracking-widest" data-id="element-76">
              +500 docentes ya lo tienen
            </span>
          </div>
          <p className="text-slate-500 text-[10px] md:text-xs font-bold uppercase tracking-widest" data-id="element-77">
            Acceso inmediato • Pago seguro • Garantía 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}